import React, { useState, useRef } from "react";
import './VideoPlayer.css';

function VideoPlayer({ albums = [] }) {
  const [selectedAlbumIndex, setSelectedAlbumIndex] = useState(0);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoElementRef = useRef(null);

  // 🛡️ SAFETY GUARD 1
  if (!Array.isArray(albums) || albums.length === 0) {
    return <p>Loading videos...</p>;
  }

  const selectedAlbum = albums[selectedAlbumIndex];

  // 🛡️ SAFETY GUARD 2
  if (!selectedAlbum || !Array.isArray(selectedAlbum.songs)) {
    return <p>No videos available</p>;
  }

  const currentVideo = selectedAlbum.songs[currentVideoIndex];

  const handleAlbumChange = (e) => {
    const newIndex = Number(e.target.value);
    setSelectedAlbumIndex(newIndex);
    setCurrentVideoIndex(0);
  };

  const handleVideoChange = (index) => {
    setCurrentVideoIndex(index);
    if (videoElementRef.current) {
      videoElementRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  return (
    <div className="video-player">
      <h3>🎥 Video Player</h3>

      <label htmlFor="video-album-select">Select Album:</label>
      <select
        id="video-album-select"
        value={selectedAlbumIndex}
        onChange={handleAlbumChange}
      >
        {albums.map((album, idx) => (
          <option key={album.name} value={idx}>
            {album.name}
          </option>
        ))}
      </select>

      <div className="album-cover">
        <img
          src={
            selectedAlbum.cover.startsWith("/")
              ? selectedAlbum.cover
              : `/${selectedAlbum.cover}`
          }
          alt={selectedAlbum.name}
          width="250"
        />
      </div>

      <div className="current-video">
        <video key={currentVideo.file} controls width="640" ref={videoElementRef}>
          <source src={currentVideo.file} type="video/mp4" />
          Your browser does not support the video element.
        </video>
      </div>

      <div className="video-list">
        {selectedAlbum.songs.map((video, idx) => (
          <button
            key={video.title}
            onClick={() => handleVideoChange(idx)}
            className={`video-btn ${idx === currentVideoIndex ? "active" : ""}`}
          >
            🎬 {video.title}
          </button>
        ))}
      </div>

    </div>
  );
}

export default VideoPlayer;